import { useEffect } from 'react'

export default function useMetaTag(name: string, content: string): void {
  useEffect(() => {
    let el = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)

    if (el) {
      el.content = content
    } else {
      el = document.createElement('meta')
      el.setAttribute('name', name)
      el.content = content
      document.head.appendChild(el)
    }

    return () => {
      el?.remove()
    }
  }, [name, content])
}
